var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"px-3 py-2 block",attrs:{"to":{ path: ("/admin/notes/" + (_vm.note.id) + "/update") }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }